"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocalizedPaths = exports.getOriginalRoute = exports.getLocalizedRoute = exports.localizedRouteMap = void 0;
const config_1 = require("./config");
// 使用共享的本地化路由映射
exports.localizedRouteMap = config_1.I18nPath.I18N_ROUTE_CONFIG;
// 生成反向映射：从本地化路径到原始路径
const reverseRouteMap = config_1.I18nPath.generateReverseRouteMap();
/**
 * 将路由模式转换为正则表达式
 * @param pattern 路由模式，如 "/cong-ty/[companyName]/[companyId]"
 * @returns 正则表达式对象
 */
const patternToRegex = (pattern) => {
    // 转义特殊字符，但保留 [...] 格式
    const escapedPattern = pattern
        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // 转义特殊字符
        .replace(/\\\[([^\]]+)\\\]/g, '([^/]+)'); // 将 [param] 转换为捕获组
    return new RegExp(`^${escapedPattern}$`);
};
/**
 * 检查路径是否匹配动态路由模式
 * @param pathname 要检查的路径
 * @param pattern 路由模式
 * @returns 如果匹配返回参数数组，否则返回 null
 */
const matchDynamicRoute = (pathname, pattern) => {
    const regex = patternToRegex(pattern);
    const match = pathname.match(regex);
    return match ? match.slice(1) : null; // 返回捕获组（排除完整匹配）
};
/**
 * 获取本地化路由（支持动态路由）
 * @param route 原始路由路径
 * @param locale 语言代码
 * @returns 本地化的路由路径
 */
const getLocalizedRoute = (route, locale) => {
    if (!locale || locale === 'en') {
        return route;
    }
    const localeRoutes = exports.localizedRouteMap[locale];
    if (!localeRoutes) {
        return route;
    }
    // 首先尝试精确匹配（用于静态路由）
    const exactMatch = localeRoutes[route];
    if (exactMatch) {
        return exactMatch;
    }
    // 如果没有精确匹配，尝试动态路由匹配
    for (const [originalPattern, localizedPattern] of Object.entries(localeRoutes)) {
        // 检查是否包含动态参数
        if (originalPattern.includes('[') && originalPattern.includes(']')) {
            const params = matchDynamicRoute(route, originalPattern);
            if (params) {
                // 构建本地化路由，替换参数
                let localizedRoute = localizedPattern;
                let paramIndex = 0;
                localizedRoute = localizedRoute.replace(/\[([^\]]+)\]/g, () => {
                    return params[paramIndex++] || '';
                });
                return localizedRoute;
            }
        }
    }
    return route;
};
exports.getLocalizedRoute = getLocalizedRoute;
/**
 * 获取原始路由（从本地化路由反向查找，支持动态路由）
 * @param localizedRoute 本地化的路由路径
 * @param locale 语言代码
 * @returns 原始路由路径
 */
const getOriginalRoute = (localizedRoute, locale) => {
    if (!locale || locale === 'en') {
        return localizedRoute;
    }
    const localeReverseRoutes = reverseRouteMap[locale];
    if (!localeReverseRoutes) {
        return localizedRoute;
    }
    // 首先尝试精确匹配（用于静态路由）
    const exactMatch = localeReverseRoutes[localizedRoute];
    if (exactMatch) {
        return exactMatch;
    }
    // 如果没有精确匹配，尝试动态路由匹配
    const localeRoutes = exports.localizedRouteMap[locale];
    if (localeRoutes) {
        for (const [originalPattern, localizedPattern] of Object.entries(localeRoutes)) {
            // 检查是否包含动态参数
            if (localizedPattern.includes('[') && localizedPattern.includes(']')) {
                const params = matchDynamicRoute(localizedRoute, localizedPattern);
                if (params) {
                    // 构建原始路由，替换参数
                    let originalRoute = originalPattern;
                    let paramIndex = 0;
                    originalRoute = originalRoute.replace(/\[([^\]]+)\]/g, () => {
                        return params[paramIndex++] || '';
                    });
                    return originalRoute;
                }
            }
        }
    }
    return localizedRoute;
};
exports.getOriginalRoute = getOriginalRoute;
/**
 * 创建本地化的 localPath 对象
 * @param locale 语言代码
 * @returns 本地化的路径对象
 */
const createLocalizedPaths = (locale) => {
    const paths = config_1.I18nPath.getPaths();
    const localizedPaths = Object.assign({}, paths);
    if (locale && locale !== 'en') {
        const localeRoutes = exports.localizedRouteMap[locale];
        if (localeRoutes) {
            Object.entries(localeRoutes).forEach(([originalPath, localizedPath]) => {
                var _a;
                // 找到对应的 localPath 键
                const pathKey = (_a = Object.entries(paths).find(([, value]) => value === originalPath)) === null || _a === void 0 ? void 0 : _a[0];
                if (pathKey) {
                    localizedPaths[pathKey] = localizedPath;
                }
            });
        }
    }
    return localizedPaths;
};
exports.createLocalizedPaths = createLocalizedPaths;
